// Sound for the hero animation: a voice line per step plus small UI effects.
// Files live in /public/landing-assets/sound (Hebrew voice only); anything missing just stays silent.
const SFX = { whoosh: 0.5, click: 0.7, pop: 0.45, ding: 0.6, chime: 0.55 };
let clips = {};
let voice = null;
let muted = false;

function load(src) {
  const a = new Audio(src);
  a.preload = 'auto';
  a.addEventListener('error', () => (a.dead = true));
  return a;
}

// Call from the click on the play button: browsers only allow audio after a tap.
export function prepareSound(steps) {
  clips = {};
  for (const name of Object.keys(SFX)) clips[name] = load(`/landing-assets/sound/${name}.mp3?v=5`);
  for (let n = 1; n <= steps; n++) clips[`step${n}`] = load(`/landing-assets/sound/he/step${n}.mp3?v=fbz8`);
  // Unlock: play and immediately pause one element inside the user gesture.
  const any = clips.click;
  any.muted = true;
  any.play().then(() => { any.pause(); any.currentTime = 0; any.muted = false; }).catch(() => {});
}

export function sfx(name) {
  const a = clips[name];
  if (muted || !a || a.dead) return;
  const c = a.cloneNode();
  c.volume = SFX[name];
  c.play().catch(() => {});
}

export function say(step) {
  if (voice) voice.pause();
  const a = clips[`step${step}`];
  if (muted || !a || a.dead) return;
  voice = a;
  a.currentTime = 0;
  a.volume = 1;
  a.play().catch(() => {});
}

// After a pause: carry on with the voice line from where it stopped.
export function resumeVoice() {
  if (muted || !voice || voice.dead || voice.ended) return;
  voice.play().catch(() => {});
}

export function stopSound() {
  if (voice) voice.pause();
}

export function setMuted(m) {
  muted = m;
  if (m) stopSound();
}
